import { Container } from "@cgc/ui/layout";
import { clsx } from "@cgc/ui/utils/clsx";
import Image from "next/image";
import React from "react";
import thinBg from "./thin-bg.png";

export type ThinHeroAlign = "centered" | "left" | "right";

type Props = {
  id: string;
  copy: React.ReactNode;
  backgroundImage?: string;
  backgroundSize?: "cover" | "contain";
  backgroundColor?: string;
  buttons?: React.ReactNode[];
  fluid?: boolean;
  align?: ThinHeroAlign;
};

const Thin: React.FC<Props> = ({
  id,
  copy,
  backgroundImage,
  backgroundSize = "cover",
  backgroundColor,
  fluid = true,
  buttons = [],
  align,
}) => {
  return (
    <Container
      id={id}
      fluid={fluid}
      {...{ ...(backgroundColor ? { style: { backgroundColor } } : null) }}
    >
      <div
        className={clsx(
          "relative flex min-h-[63px] items-center md:h-[214px]",
          !backgroundColor && "bg-cgc-blue",
        )}
      >
        <Image
          src={backgroundImage ?? thinBg}
          alt=""
          priority={true}
          fill
          className={clsx(
            "absolute object-contain",
            // backgroundImage && backgroundSize === "contain" && "object-contain",
            backgroundImage && backgroundSize === "cover" && "object-cover",
          )}
          quality={100}
        />
        <div
          className={clsx(
            "relative z-10 flex h-full w-full flex-col items-center justify-center p-4 text-center",
            align === "left" && "items-start text-left",
            align === "right" && "items-end text-right",
          )}
        >
          <div className="text-cgc-white">{copy}</div>
          {buttons.length > 0 && <div className="space-x-2">{buttons}</div>}
        </div>
      </div>
    </Container>
  );
};

export default Thin;
